// extracted by mini-css-extract-plugin
module.exports = {"banner1":"Support_banner1__3tDA7","card-container":"Support_card-container__3c43Q","card":"Support_card__3q2Vv","card1":"Support_card1__1hCet","card2":"Support_card2__16mjO"};